//require('react-hot-loader/patch')
import React from 'react';
import ReactDOM from 'react-dom';
import { hot } from 'react-hot-loader'
// import { Router, Route, IndexRoute, IndexRedirect, Link, browserHistory } from 'react-router'

// Keep this above component imports to maintain proper CSS ordering
import 'styles/main.styl'

import { Provider } from 'react-redux'


import store from 'state/index.js'
import { PRIMARY_EXAMPLE_ACTION } from 'state/action-types'
import config from 'config'



import App from './app'

// Import required services
import Auth from 'services/auth'
import Base  from 'components/base'


// const Root = hot(module)(
// 	<Provider store={store}>
// 		<Base />
// 	</Provider>
// )

// console.warn(Root)

ReactDOM.render(<App />, document.getElementById('root'))




// WEBPACK FOOTER //
// ./index.js